<script setup>
import PageHeader from "@/themes/dark/layouts/PageHeader.vue";
import PageFooter from "@/themes/dark/layouts/PageFooter.vue";
</script>

<template>
    <div class="page-container">
        <page-header/>
        <div class="page-viewer">
            <router-view />
        </div>
        <page-footer/>
    </div>
</template>

<style scoped>
@import "./layout.scss";
</style>
